module.exports = __webpack_public_path__ + "static/media/user_colors.a67e3ed0.svg";